import './form-rich-text-field.scss';

import { Controller, useFormContext } from 'react-hook-form';
import { FC, useEffect } from 'react';
import { FormHelperText, TextFieldProps } from '@mui/material';

import { ConvergeInputLabel } from './converge-input-label';
import { FormFieldContainer } from './form-field-container';
import { RichTextEditor } from './rich-text-editor/rich-text-editor';
import { useSetDirtyValue } from '../hooks';

export type FormRichTextFieldProps = {
  name: string;
  containerWidth?: number;
  minHeight?: number;
  hideMenu?: boolean;
  onBlur?: (value: string) => void;
  showToolbarEvenIfNotEditable?: boolean;
  labelMargin?: number;
  minHeightForTextFile?: number;
  dataTestId?: string;
} & Omit<TextFieldProps, 'onBlur'>;

export const FormRichTextField: FC<FormRichTextFieldProps> = ({
  name,
  label,
  hideMenu,
  required,
  disabled,
  containerWidth = 6,
  minHeight,
  hiddenLabel,
  onBlur,
  labelMargin,
  minHeightForTextFile,
  showToolbarEvenIfNotEditable,
  value,
  defaultValue,
  dataTestId,
}) => {
  const { control, setValue } = useFormContext();
  const { setDirtyValue } = useSetDirtyValue();

  useEffect(() => {
    if (value) {
      setValue(name, value);
    }
  }, [value, name, setValue]);

  return (
    <Controller
      control={control}
      name={name}
      render={({ fieldState, field }) => (
        <FormFieldContainer
          md={containerWidth}
          style={{ minHeight: minHeight + 'px' }}
        >
          {hiddenLabel !== true && (
            <ConvergeInputLabel
              label={label}
              required={required}
              style={{ marginBottom: `${labelMargin}px` }}
            />
          )}

          <RichTextEditor
            onChange={(newValue) => {
              setDirtyValue(name, newValue);
            }}
            hideMenu={hideMenu}
            editable={!disabled}
            value={field.value || (value as string)}
            onBlur={(value) => onBlur && onBlur(value)}
            showToolbarEvenIfNotEditable={showToolbarEvenIfNotEditable}
            minHeightForTextFile={minHeightForTextFile}
            dataTestId={dataTestId}
          />

          {fieldState.error && typeof fieldState.error === 'string' && (
            <FormHelperText
              error
              className="form-rich-text-field-form-helper-text-error"
            >
              {fieldState.error}
            </FormHelperText>
          )}
        </FormFieldContainer>
      )}
    />
  );
};
